export const LOGIN = '/login';
export const IE_ERROR = '/ie-error';
export const DASHBOARD = '/';
export const APPLICATION = '/application';
export const CALLCENTER = '/callCenter';
export const CARD_ENTRY = '/application/card-entry';
export const RESULT = '/application/result';
export const ONLINE_POS = '/application/online-pos';
export const CARD_OBSERVATION = '/application/card-observation';
export const CLIENT_INFO = '/application/client-info';
export const UPLOAD_DOCUMENT = '/application/upload-document';
export const CARD_REISSUE = '/application/card-reissue';
export const EXECUTED_OPERATIONS = '/application/executed-operations';
export const CHANGE_PASSWORD = '/change-password';
export const PROFILE_MENU = '/profile-menu';
export const CONTACT_INFO = '/contact-info';
export const NEW_SETTLEMENT = '/new-settlement';
export const NEW_OBSERVE = '/new-observe';
export const USER_MANUAL = '/user-manual';
export const LOAN_APPLICATION = '/application/loan-application';
export const VIEW_CREDITS = '/view-credits';
export const CC_MONEY_TRANSFER_HISTORY = '/callCenter/money-transfer-history';
export const INTRABANK_MONEY_TRANSFER_HISTORY = '/callCenter/money-transfer-history-intrabank';
export const PLASTIC_CARD_REGISTRATION = '/application/plastic-card-registration';
export const PROBLEM_TRACKING_SYSTEM = '/application/problem-tracking-system';
export const PAYMENT_PLAN_SIMULATION = '/application/payment-plan-simulation';
export const ALL_ACCOUNT_OBSERVATION = '/application/all-account-observation';

type MapBreadcrumbTextType = {
  application: string;
  [path: string]: string;
};

export const mapBreadcrumbText: MapBreadcrumbTextType = {
  application: 'general_components_leftMenu_application_label',
  callCenter: 'general_components_leftMenu_callCenter_label',
  'card-entry': 'general_components_subMenu_cardEntry_label',
  result: 'general_result_text',
  'online-pos': 'posActivation_subMenu_text',
  'card-observation': 'cardObservation_title',
  'client-info': 'general_components_subMenu_changeFundClientInfo_label',
  'upload-document': 'uploadDocuments_stepper_uploadDocuments_text',
  'card-reissue': 'general_components_subMenu_cardReissue_label',
  'executed-operations': 'general_components_subMenu_executedOperations_label',
  'change-password': 'passwordChange_menu_text',
  'contact-info': 'general_components_subMenu_changeContactInfo_label',
  'new-settlement': 'general_components_subMenu_newSettlement_label',
  'new-observe': 'general_components_subMenu_newObserve_label',
  'user-manual': 'general_components_subMenu_userManual_label',
  'loan-application': 'general_components_subMenu_loanApp_label',
  'view-credits': 'general_components_subMenu_viewCredits_label',
  'money-transfer-history': 'general_components_subMenu_interbankMoneyTransferHistory_label',
  'money-transfer-history-intrabank':
    'general_components_subMenu_intrabankMoneyTransferHistory_label',
  'plastic-card-registration': 'general_components_subMenu_plasticCardRegistration_label',
  'problem-tracking-system': 'general_components_subMenu_problemTrackingSystem_label',
  'payment-plan-simulation': 'general_components_subMenu_PPSimulation_label',
  'all-account-observation': 'general_components_subMenu_allAccObservation_label',
};

export const MenuRoutes: { [id: string]: string } = {
  CEA10000: DASHBOARD,
  CEA20000: APPLICATION,
  CEA30000: CALLCENTER,
};
export const SubMenuRoutes: { [id: string]: string } = {
  CEA20001: PLASTIC_CARD_REGISTRATION,
  CEA20002: PROBLEM_TRACKING_SYSTEM,
  CEA20004: PAYMENT_PLAN_SIMULATION,
  CEA20200: ALL_ACCOUNT_OBSERVATION,
  CEA21000: CARD_ENTRY,
  CEA22000: ONLINE_POS,
  CEA23000: CARD_OBSERVATION,
  CEA24000: CLIENT_INFO,
  CEA25000: UPLOAD_DOCUMENT,
  CEA26000: CARD_REISSUE,
  CEA27000: EXECUTED_OPERATIONS,
  CEA28000: CONTACT_INFO,
  CEA29000: NEW_SETTLEMENT,
  CEA30000: NEW_OBSERVE,
  CEA33000: LOAN_APPLICATION,
  CEA34000: VIEW_CREDITS,
  CEA30001: CC_MONEY_TRANSFER_HISTORY,
  CEA30002: INTRABANK_MONEY_TRANSFER_HISTORY,
};
export const ProfileMenuRoutes: { [id: string]: string } = {
  CEA99000: PROFILE_MENU,
  CEA99100: CHANGE_PASSWORD,
  CEA99200: USER_MANUAL,
};

export const MenuIds = {
  APPLICATION: 'CEA20000',
  CALL_CENTER: 'CEA30000',
};
export const SubMenuIds = {
  PLASTIC_CARD_REGISTRATION: 'CEA20001',
  PROBLEM_TRACKING_SYSTEM: 'CEA20002',
  PAYMENT_PLAN_SIMULATION: 'CEA20004',
  CARD_ENTRY: 'CEA21000',
  ONLINE_POS: 'CEA22000',
  CARD_OBSERVATION: 'CEA23000',
  CLIENT_INFO: 'CEA24000',
  UPLOAD_DOCUMENTS: 'CEA25000',
  CARD_REISSUE: 'CEA26000',
  EXECUTED_OPERATIONS: 'CEA27000',
  CONTACT_INFO: 'CEA28000',
  NEW_SETTLEMENT: 'CEA29000',
  NEW_OBSERVE: 'CEA30000',
  LOAN_APPLICATION: 'CEA33000',
  VIEW_CREDITS: 'CEA34000',
  CC_MONEY_TRANSFER_HISTORY: 'CEA30001',
  INTRABANK_MONEY_TRANSFER_HISTORY: 'CEA30002',
  ALL_ACCOUNT_OBSERVATION: 'CEA20200',
};
export const ProfileMenuIds = {
  PROFILE_MENU: 'CEA99000',
  CHANGE_PASSWORD: 'CEA99100',
  USER_MANUAL: 'CEA99200',
};
